<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import AddIntegration from "@/own/components/datahub/integrations/AddIntegration";
import EditIntegration from "@/own/components/datahub/integrations/EditIntegration";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
  UPDATE_CREATE_DATA,
} from "@/core/services/store/integrations.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "Integrations",
  components: { DataTable },
  data: () => ({
    componentForEditing: EditIntegration,
    componentForAdding: AddIntegration,
    delete_url: `${process.env.VUE_APP_BASE_URL}/datahub/integrations/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      UPDATE_CREATE_DATA: UPDATE_CREATE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getINTEGRATIONSTableFilters",
      getTableState: "getINTEGRATIONSTableState",
      getTableData: "getINTEGRATIONSTableData",
      getTableHeaders: "getINTEGRATIONSTableHeaders",
      getTableProperties: "getINTEGRATIONSTableProperties",
      getTableExportUrl: "getINTEGRATIONSExportUrl",
      getTablePermissions: "getINTEGRATIONSTablePermissions",
    },
    urls: {
      delete: `${process.env.VUE_APP_BASE_URL}/datahub/integrations/destroy`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store
        .dispatch(this.table_state.UPDATE_CREATE_DATA, {})
        .then(() => {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
